import script from "./MyFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./MyFooter.vue?vue&type=script&setup=true&lang=js"

import "./MyFooter.vue?vue&type=style&index=0&id=04318504&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04318504"]])

export default __exports__